var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2160,
    height: 291,
    viewBox: "0 0 2160 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.786 6.15088L850.465 146.984L771.786 98.8951M771.786 6.15088V98.8951M771.786 6.15088L693.107 146.984L771.786 98.8951M926.143 280.151L850.322 146.984L926.143 192.489M926.143 280.151V192.489M926.143 280.151L1001.96 146.984L926.143 192.489M617.429 280.151L693.249 146.984L617.429 192.489M617.429 280.151V192.489M617.429 280.151L541.608 146.984L617.429 192.489M1080.5 6.15088L1159.18 146.984L1080.5 98.8951M1080.5 6.15088V98.8951M1080.5 6.15088L1001.82 146.984L1080.5 98.8951M1234.86 280.151L1159.04 146.984L1234.86 192.489M1234.86 280.151V192.489M1234.86 280.151L1310.68 146.984L1234.86 192.489M1389.21 6.15088L1467.89 146.984L1389.21 98.8951M1389.21 6.15088V98.8951M1389.21 6.15088L1310.54 146.984L1389.21 98.8951M1543.57 280.151L1467.75 146.984L1543.57 192.489M1543.57 280.151V192.489M1543.57 280.151L1619.39 146.984L1543.57 192.489M463.071 6.15088L541.751 146.984L463.071 98.8951M463.071 6.15088V98.8951M463.071 6.15088L384.392 146.984L463.071 98.8951M308.714 280.151L384.535 146.984L308.714 192.489M308.714 280.151V192.489M308.714 280.151L232.893 146.984L308.714 192.489M154.357 6.15088L233.036 146.984L154.357 98.8951M154.357 6.15088V98.8951M154.357 6.15088L75.6779 146.984L154.357 98.8951M1697.93 6.15088L1776.61 146.984L1697.93 98.8951M1697.93 6.15088V98.8951M1697.93 6.15088L1619.25 146.984L1697.93 98.8951M1852.29 280.151L1776.46 146.984L1852.29 192.489M1852.29 280.151V192.489M1852.29 280.151L1928.11 146.984L1852.29 192.489M2006.64 6.15088L2085.32 146.984L2006.64 98.8951M2006.64 6.15088V98.8951M2006.64 6.15088L1927.96 146.984L2006.64 98.8951M0 280.151L75.8208 146.984L0 192.489V280.151ZM2161 280.151L2085.18 146.984L2161 192.489V280.151Z",
    stroke: "white",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1928 29.1509L1852.5 151.151L1777 29.1509H1852.5H1928Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773 267.151L1697.5 145.151L1622 267.151H1697.5H1773Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310 29.1509L1234.5 151.151L1159 29.1509H1234.5H1310Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156 267.151L1080.5 145.151L1005 267.151H1080.5H1156Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693 29.1509L617.5 151.151L542 29.1509H617.5H693Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 267.151L463.5 145.151L388 267.151H463.5H539Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001 29.1509L925.5 151.151L850 29.1509H925.5H1001Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847 267.151L771.5 145.151L696 267.151H771.5H847Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 29.1509L309.5 151.151L234 29.1509H309.5H385Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 29.1509L309.5 151.151L234 29.1509H309.5H385Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 29.1509L0.5 151.151L-75 29.1509H0.5H76Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 267.151L154.5 145.151L79 267.151H154.5H230Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2235 29.1509L2159.5 151.151L2084 29.1509H2159.5H2235Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2082 267.151L2006.5 145.151L1931 267.151H2006.5H2082Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619 29.1509L1543.5 151.151L1468 29.1509H1543.5H1619Z",
    stroke: "#64A696",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465 267.151L1389.5 145.151L1314 267.151H1389.5H1465Z",
    stroke: "#64A696",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.b4c17cb2b97050f7f199fad5c4fdeeb8.svg";
export { ForwardRef as ReactComponent };